import React from 'react';
import { useTranslation } from 'react-i18next';

export const getTranslatedPlanName = (t, planCode) => {
    const planNames = {
        free: t('plan.free'),
        basic: t('plan.basic'),
        advanced: t('plan.advanced'),
        pro: t('plan.pro'),
        excel_transition: t('plan.excel_transition', {defaultValue: 'Přechod z Excelu'}),
        growing_eshop: t('plan.growing_eshop', {defaultValue: 'Rostoucí e-shop'}),
        strong_eshop: t('plan.strong_eshop', {defaultValue: 'Silný e-shop'}),
    };

    return planNames[planCode] ?? null;
};

const PlanName = ( { planCode, className, withoutSubscription = false } ) => {
    const { t } = useTranslation();

    const planName = withoutSubscription
        ? t('plan.no_subscription', {defaultValue: 'Bez předplatného'})
        : getTranslatedPlanName(t, planCode) ?? t('plan.individual', {defaultValue: 'Individuální'});

    return (
        <span className={className}>{planName}</span>
    );
};

export default PlanName;
